var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';

import { Translate } from "../../../../I18N";
import { Tooltip } from 'flowbite-react';

const IndeterminateCheckboxRow = (

{
  row


}) => {
  const ref = useRef(null);
  const checked = row.getIsSelected();
  const disabled = !row.getCanSelect();
  const onChange = row.getToggleSelectedHandler();
  const disableReason = row.original.disableRowSelection;
  useEffect(() => {
    ref.current.checked = Boolean(checked);
  }, [ref, checked]);

  const checkbox = /*#__PURE__*/
  React.createElement("input", {
    type: "checkbox",
    ref: ref,
    className: "bg-gray-50 rounded border-gray-300 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
    disabled: disabled,
    onChange: onChange,
    key: row.id,
    id: row.id,
    checked: checked }
  );


  return (/*#__PURE__*/
    _jsx("label", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "sr-only" }, void 0, "Select"),
    disabled && typeof disableReason !== 'boolean' ? /*#__PURE__*/
    _jsx(Tooltip, {
      content: /*#__PURE__*/_jsx("div", { className: "text-xs text-gray-600 w-40" }, void 0, disableReason)
      // eslint-disable-next-line react/style-prop-object
      , style: "light" }, void 0, /*#__PURE__*/

    _jsx("span", {}, void 0, checkbox)
    ) :

    checkbox

    ));

};

// eslint-disable-next-line comma-spacing
const IndeterminateCheckboxHeader = ({ table }) => {
  const ref = useRef(null);
  const checked = table.getIsAllRowsSelected();
  const indeterminate = table.getIsSomeRowsSelected();
  const onChange = table.getToggleAllRowsSelectedHandler();

  useEffect(() => {
    ref.current.checked = Boolean(checked);
    ref.current.indeterminate = Boolean(indeterminate && !checked);
  }, [ref, indeterminate, checked]);

  return (/*#__PURE__*/
    _jsx("label", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "sr-only" }, void 0, "Select all"), /*#__PURE__*/
    React.createElement("input", {
      type: "checkbox",
      ref: ref,
      className: "bg-gray-50 rounded border-gray-300 cursor-pointer",
      onChange: onChange,
      key: "checkbox-header",
      id: "checkbox-header" }
    )
    ));

};

export { IndeterminateCheckboxRow, IndeterminateCheckboxHeader };